var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1490_129098)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4299 18.7826H8.34294C6.61406 18.7826 5.21251 17.3811 5.21251 15.6522V13.5652H3.12555C1.39667 13.5652 -0.00488281 12.1637 -0.00488281 10.4348V3.13044C-0.00488281 1.40155 1.39667 0 3.12555 0H10.4299C12.1588 0 13.5603 1.40155 13.5603 3.13044V5.21739H15.6473C17.3762 5.21739 18.7777 6.61894 18.7777 8.34783V10.4348H20.8647C22.5936 10.4348 23.9951 11.8363 23.9951 13.5652V20.8696C23.9951 22.5985 22.5936 24 20.8647 24H13.5603C11.8314 24 10.4299 22.5985 10.4299 20.8696V18.7826ZM10.4299 16.6957V13.5652C10.4299 11.8363 11.8314 10.4348 13.5603 10.4348H16.6908V8.34783C16.6908 7.77153 16.2236 7.30435 15.6473 7.30435H8.34294C7.76665 7.30435 7.29947 7.77153 7.29947 8.34783V15.6522C7.29947 16.2285 7.76665 16.6957 8.34294 16.6957H10.4299ZM5.21251 11.4783V8.34783C5.21251 6.61894 6.61406 5.21739 8.34294 5.21739H11.4734V3.13044C11.4734 2.55414 11.0062 2.08696 10.4299 2.08696H3.12555C2.54926 2.08696 2.08207 2.55414 2.08207 3.13044V10.4348C2.08207 11.0111 2.54926 11.4783 3.12555 11.4783H5.21251ZM13.5603 12.5217C12.984 12.5217 12.5169 12.9889 12.5169 13.5652V20.8696C12.5169 21.4459 12.984 21.913 13.5603 21.913H20.8647C21.441 21.913 21.9082 21.4459 21.9082 20.8696V13.5652C21.9082 12.9889 21.441 12.5217 20.8647 12.5217H13.5603Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1490_129098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.00488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkUpload);
export default __webpack_public_path__ + "static/media/bulk_upload.399042e9065b90a42d1a955d99cb1e89.svg";
export { ForwardRef as ReactComponent };